/**
 * Shown when user accesses a route they're not allowed to
 */

import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Unauthorized() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const role = user?.role || location.state?.role || '';
  const roleLabel = role ? String(role).replace(/_/g, ' ').toLowerCase() : '';
  const needsAdmin = (location.state?.from || '').includes('/admin');
  const signedInAsOtherRole = Boolean(role) && role !== 'ADMIN' && role !== 'SUPER_ADMIN';

  const handleAdminLogin = async () => {
    await logout();
  };

  return (
    <div className="page-loader px-4">
      <div className="card max-w-md w-full p-8 text-center">
        <div
          className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-4 text-2xl font-semibold"
          style={{ background: 'rgb(99 102 241 / 0.12)', color: 'rgb(79 70 229)' }}
        >
          !
        </div>
        <h1 className="page-title text-xl">Access denied</h1>
        <p className="page-subtitle mt-2">
          {signedInAsOtherRole
            ? `You're signed in as a ${roleLabel}. ${needsAdmin ? 'Institute admins can open this page.' : 'You do not have permission to view this page.'}`
            : 'You do not have permission to view this page.'}
        </p>
        {signedInAsOtherRole ? (
          <Link to="/login" onClick={handleAdminLogin} className="btn-primary inline-flex mt-6 px-6">
            Sign in as admin
          </Link>
        ) : (
          <Link to="/" className="btn-primary inline-flex mt-6 px-6">
            Go to dashboard
          </Link>
        )}
      </div>
    </div>
  );
}
